$(function () {
    window.redirectToScreen = function (url) {
        window.location.href = url;
    };

    window.navigateInNewTab = function (url) {
        window.open(url, "_blank");
    };

    $('form button[type="submit"]').click(function () {
        $(this).prop("disabled", true).addClass("inactive");
        $(this).closest("form").submit();
    });

    $('.number-key-press').on('keypress', function (event) {
        var pattern = /^[0-9]$/;
        var char = String.fromCharCode(event.which || event.keyCode);
    
        if (!pattern.test(char)) {
            event.preventDefault();
        }
    });

    $("#agree").change(function () {
        var registerInput = $("#register-input");
        if ($(this).is(":checked")) {
            registerInput.prop("disabled", false);
            registerInput.removeClass("inactive");
        } else {
            registerInput.prop("disabled", true);
            registerInput.addClass("inactive");
        }
    });

    function getDaysInMonth(year, month) {
        return new Date(year, month, 0).getDate();
    }

    window.populateDays = function (year, month) {
        const daysInMonth = getDaysInMonth(year, month);
        if (isNaN(daysInMonth) || daysInMonth < 1) {
            console.error("Invalid number of days in month");
            return;
        }

        const daySelect = $(".select-day");
        daySelect.empty().append("<option value=''>選択</option>");

        const fragment = document.createDocumentFragment();
        for (let day = 1; day <= daysInMonth; day++) {
            const option = $("<option>", {
                value: day,
                text: day,
            })[0];
            fragment.appendChild(option);
        }
        daySelect.append(fragment);
    };

    $(".select-year, .select-month").change(function () {
        var year = $(".select-year").val();
        var month = $(".select-month").val();
        if (year && month) {
            populateDays(year, month);
        }
    });

    // CF0060 Common postal code address search
    $("#get-address-by-postal-code").click(function () {
        let postalCode = $('input[name="mailing_postal_code"]').val();
        let elmPrefecturesCode = $('select[name="prefectures_code"]');
        let elmMunicipalities = $('input[name="municipalities"]');
        let blockNumber = $('input[name="block_number"]');
        let streetNumber = $('input[name="street_number"]');
        elmMunicipalities.val("");
        elmPrefecturesCode.val("");
        blockNumber.val("");
        streetNumber.val("");

        return $.getJSON(typeof ROUTE_GET_ZIPCODE != 'undefined' ? ROUTE_GET_ZIPCODE : "/get-zipcoda", {
            zipcode: postalCode,
        }).then((data) => {
            if (data.status == 200) {
                let item = data.items[0];
                elmPrefecturesCode.find("option").each(function () {
                    this.selected = this.text == item.pref;
                });
                elmMunicipalities.val(item.components[1]);
                blockNumber.val(item.components[2]);
                streetNumber.val(item.components[3]);
            }
        });
    });

    $(document).on(
        "click",
        ".address-by-postal-code-button",
        async function () {
            // TODO: Refactor this code to use CF0060 Common postal code address search
            var parent = $(this).closest(".add-collection-address");
            let postalCode = $(parent).find(".mailing-postal-code").val();
            let elmPrefecturesCode = $(parent).find(".prefectures-code");
            let elmMunicipalities = $(parent).find(".municipalities");
            let elmPrefectures = $(parent).find(".prefectures");
            let blockNumber = $(parent).find(".block-number");
            let streetNumber = $(parent).find(".street-number");
            elmMunicipalities.val("");
            elmPrefecturesCode.val("");
            elmPrefectures.val("");
            blockNumber.val("");
            streetNumber.val("");

            try {
                const data = await $.getJSON(typeof ROUTE_GET_ZIPCODE != 'undefined' ? ROUTE_GET_ZIPCODE : "/get-zipcoda", {
                    zipcode: postalCode,
                });
                if (data.status == 200) {
                    let item = data.items[0];
                    elmPrefecturesCode.find("option").each(function () {
                        this.selected = this.text == item.pref;
                    });
                    elmMunicipalities.val(item.components[1]);
                    blockNumber.val(item.components[2]);
                    streetNumber.val(item.components[3]);

                    // add trigger change for select
                    elmPrefecturesCode.trigger("change");
                }
            } catch (err) {
                var response = err.responseJSON;
            }
        }
    );

    // on change select and add data to hidden input
    $(".select-change").on("change", function () {
        // get data-name attribute from option selected
        var value = $(this).find("option:selected").data("name");
        // get hidden input after select
        var hidden = $(this).parent().find('input[type="hidden"]');
        // set value to hidden input
        hidden.val(value);
    });

    // onclick event for back button
    $(".back-button").on("click", function () {
        // get route from data attribute
        var route = $(this).data("route");
        if (route == undefined || route == "") {
            return;
        }
        redirectToScreen(route);
    });

    // onclick event for edit-redirect-button
    $(".edit-redirect-button").on("click", function () {
        // get route from data attribute
        var route = $(this).data("route");
        if (route == undefined || route == "") {
            return;
        }
        redirectToScreen(route);
    });

    $(".to-top").on("click", function () {
        $(window).scrollTop(0);
    });

    $(document).on("keypress", function (e) {
        if (e.which === 13) {
            // get button type submit and not focus
            var buttonTypeSubmit = $(".wrapper").find('button[type="submit"]');
            if (
                buttonTypeSubmit.length > 0 &&
                !$(buttonTypeSubmit).is(":focus")
            ) {
                // check has button not type submit but focus
                var buttonNotTypeSubmit = $(".wrapper").find(
                    'button:not([type="submit"])'
                );
                if (
                    buttonNotTypeSubmit.length > 0 &&
                    $(buttonNotTypeSubmit).is(":focus")
                ) {
                    return;
                }
                // get item in form has focus
                var itemFocus = $(":focus");
                // check if item focus is form search
                if (
                    itemFocus.length > 0 &&
                    $(itemFocus).closest(".search-form").length > 0
                ) {
                    return;
                }
                // check if item focus is textarea
                if (itemFocus.length > 0 && $(itemFocus).is("textarea")) {
                    return;
                }
                e.preventDefault();
            }
        }
    });

    // Rename input, select fields with new index
    window.renameInputFields = function (
        elements,
        pattern,
        isReset = false,
        indexElement = 0
    ) {
        // if element is not array then convert to array
        if (indexElement != 0) {
            elements = [elements];
        }

        //find all input fields and select fields
        $(elements).each(function (index) {
            index = indexElement != 0 ? indexElement : index;
            $(this)
                .find("input, select")
                .each(function () {
                    var self = $(this);
                    var name = $(self).attr("name");
                    var value = $(self).val();
                    if (name != undefined) {
                        let newName = name.replace(pattern, (match, p1, p2) => {
                            if (p1) {
                                return "[" + index + "]";
                            }

                            if (p2) {
                                return "[" + p2 + (index + 1) + "]";
                            }

                            return match;
                        });

                        $(self).attr("name", newName);

                        if (isReset) {
                            if ($(self).attr("type") == "file") {
                                $(self).attr("value", "");
                            }
                            $(self).val("");
                        } else {
                            // check type = file
                            if ($(self).attr("type") != "file") {
                                $(self).val(value);
                            }
                        }
                    }
                });
        });
    };

    // Rename id input fields with new index
    window.renameIdInputFields = function (
        elements,
        pattern,
        indexElement = 0
    ) {
        // if element is not array then convert to array
        if (indexElement != 0) {
            elements = [elements];
        }

        //find all input fields and select fields
        $(elements).each(function (index) {
            index = indexElement != 0 ? indexElement : index;
            $(this)
                .find("input, select")
                .each(function () {
                    var self = $(this);
                    var id = $(self).attr("id");
                    if (id != undefined) {
                        let newId = id.replace(pattern, (match, p1) => {
                            if (p1) {
                                return "-" + index;
                            }

                            return match;
                        });

                        $(self).attr("id", newId);
                    }
                });

            //for of label
            $(this)
                .find("label")
                .each(function () {
                    var self = $(this);
                    var forLabel = $(self).attr("for");
                    if (forLabel != undefined) {
                        let newFor = forLabel.replace(pattern, (match, p1) => {
                            if (p1) {
                                return "-" + index;
                            }

                            return match;
                        });

                        $(self).attr("for", newFor);
                    }
                });
        });
    };

    window.convertPriceComma = function (value) {
        var number = value ? parseInt(value) : 0;
        return number.toLocaleString("en-US");
    };

    $(".price-comma").each(function () {
        var value = $(this).text();
        $(this).text(convertPriceComma(value));
    });

    window.removeOptionSelect = function (nameYear, nameMonth, nameDay) {
        // remove all option except first option
        $('select[name="' + nameYear + '"] option').each(function() {
            if ($(this).val() != '') {
                $(this).remove();
            }
        });

        $('select[name="' + nameMonth + '"] option').each(function() {
            if ($(this).val() != '') {
                $(this).remove();
            }
        });

        $('select[name="' + nameDay + '"] option').each(function() {
            if ($(this).val() != '') {
                $(this).remove();
            }
        });
    }

    window.inacticeOptionSelect = function (nameYear, nameMonth, nameDay, minDate, maxDate) {
        // selected nameYear
        var selectedYear = $('select[name="' + nameYear + '"]').attr('data-selected');
    
        // selected nameMonth
        var selectedMonth = $('select[name="' + nameMonth + '"]').attr('data-selected');

        // selected nameDay
        var selectedDay = $('select[name="' + nameDay + '"]').attr('data-selected');

        removeOptionSelect(nameYear, nameMonth, nameDay);

        // append option in select nameYear when date < minDate or date > maxDate, start is minDate
        for (var i = minDate.getFullYear(); i <= maxDate.getFullYear(); i++) {
            $('select[name="' + nameYear + '"]').append($('<option>', {
                value: i,
                text: i
            }));
        }
    
        // append option in select nameMonth belong to selectedYear and date < minDate or date > maxDate
        for (var month = 1; month <= 12; month++) {
            if (selectedYear == minDate.getFullYear() && month < minDate.getMonth() + 1) {
                continue;
            } else if (selectedYear == maxDate.getFullYear() && month > maxDate.getMonth() + 1) {
                continue;
            }
            $('select[name="' + nameMonth + '"]').append($('<option>', {
                value: month,
                text: month
            }));
        }

        // append option in select nameDay belong to selectedMonth and date < minDate or date > maxDate
        // get list day in month
        var daysInMonth = getDaysInMonth(selectedYear, selectedMonth);
        for (var day = 1; day <= daysInMonth; day++) {
            if (selectedYear == minDate.getFullYear() && selectedMonth == minDate.getMonth() + 1 && day < minDate.getDate()) {
                continue;
            }
            else if (selectedYear == maxDate.getFullYear() && selectedMonth == maxDate.getMonth() + 1 && day > maxDate.getDate()) {
                continue;
            }
            $('select[name="' + nameDay + '"]').append($('<option>', {
                value: day,
                text: day
            }));
        }

        resetOptionDisplayNone(nameYear, nameMonth, nameDay, selectedYear, parseInt(selectedMonth), parseInt(selectedDay));
    };

    window.getMinDateExtended = function (appliedAt, firstAppliedAt, oldCourseCd, oldCourses, isCreatedFromExtended) {
        const min = new Date(firstAppliedAt || appliedAt);
        const totalBeforeOldCourse = oldCourses.reduce((sum, course) => sum + parseInt(course || 0), 0);
        const totalOldCourses = isCreatedFromExtended == 1
            ? totalBeforeOldCourse
            : parseInt(oldCourseCd || 0) + totalBeforeOldCourse;
        min.setFullYear(min.getFullYear() + totalOldCourses);
        return min;
    }

    window.resetOptionDisplayNone = function (nameYear, nameMonth, nameDay, selectedYear, selectedMonth, selectedDay) {
        // set value for year, month, day
        if (selectedYear && $('select[name="' + nameYear + '"] option[value="' + selectedYear + '"]').length > 0) {
            $('select[name="' + nameYear + '"]').val(selectedYear);
        } else {
            $('select[name="' + nameYear + '"]').val('');
            $('select[name="' + nameYear + '"]').attr('data-selected', '');
        }

        if (selectedMonth && $('select[name="' + nameMonth + '"] option[value="' + selectedMonth + '"]').length > 0) {
            $('select[name="' + nameMonth + '"]').val(selectedMonth);
        } else {
            $('select[name="' + nameMonth + '"]').val('');
            $('select[name="' + nameMonth + '"]').attr('data-selected', '');
        }

        if (selectedDay && $('select[name="' + nameDay + '"] option[value="' + selectedDay + '"]').length > 0) {
            $('select[name="' + nameDay + '"]').val(selectedDay);
        } else {
            $('select[name="' + nameDay + '"]').val('');
            $('select[name="' + nameDay + '"]').attr('data-selected', '');
        }

        // reset month and day when year is empty
        if ($('select[name="' + nameYear + '"]').val() == '') {
            $('select[name="' + nameMonth + '"]').val('');
            $('select[name="' + nameMonth + '"]').attr('data-selected', '');
            $('select[name="' + nameDay + '"]').val('');
            $('select[name="' + nameDay + '"]').attr('data-selected', '');
        }

        // reset day when month is empty
        if ($('select[name="' + nameMonth + '"]').val() == '') {
            $('select[name="' + nameDay + '"]').val('');
            $('select[name="' + nameDay + '"]').attr('data-selected', '');
        }
    }

    window.resetValueInputFields = function (element) {
        //find all input fields and select fields
        $(element).find('input, select').each(function() {
            $(this).val('');
        });
    }

    window.formatFileSize = function (bytes) {
        // show GB
        var type = '';
        if (bytes >= 1073741824) {
            bytes = (bytes / 1073741824).toFixed(2);
            type = 'GB';
        }
        // show MB
        else if (bytes >= 1048576) {
            bytes = (bytes / 1048576).toFixed(2);
            type = 'MB';
        }
        // show KB
        else if (bytes >= 1024) {
            bytes = (bytes / 1024).toFixed(2);
            type = 'KB';
        } else {
            bytes = bytes;
            type = 'bytes';
        }
        return {
            bytes: bytes,
            type: type
        };
    }

    window.convertFileSizes = function () {
        // loop file-size
        $('.file-size').each(function() {
            var fileSize = $(this).data('size');
            if (fileSize) {
                var dataSize = formatFileSize(fileSize);
                $(this).find('.text-color-danger').text(dataSize.bytes);
                $(this).find('.type-size').text(dataSize.type);
            }
        });
    }

    convertFileSizes();

    window.formatYYYMMDD = function (dateString) {
        if (dateString) {
            dateString = dateString.split('-').map((part, index) => index > 0 && part.length === 1 ? '0' + part : part).join('/');
        }
        return dateString;
    }
});


// エラー項目へのフォーカス設定
document.addEventListener('DOMContentLoaded', function() {
    // 少し遅延を入れてフォーカスを設定
    setTimeout(() => {
        // エラーのある要素を取得
        const errorElements = document.querySelectorAll('.has-danger');
        
        // エラー要素が存在する場合
        if (errorElements.length > 0) {
            // 最初のエラー要素内のフォーム要素（input, select, textarea）を取得
            const firstFormElement = errorElements[0].querySelector('input[type="text"], select, textarea');
            
            // フォーム要素が存在する場合はフォーカスを設定
            if (firstFormElement) {
                firstFormElement.focus();

                firstFormElement.scrollIntoView({ 
                    behavior: 'smooth', 
                    block: 'center' 
                });
            }
           // お預かり 同意するチェック
            else if (document.querySelector('.checkbox-input.has-danger')) {
                document.getElementById('checkbox-section').scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, 100); // 100ミリ秒の遅延を設定
});